<div *ngIf="currentScreen === 'WebrtcfeedsScreen'" id="webrtcfeeds-component" class="h-100 bg-image"
    style="background-image: url('assets/img/default-login.jpg')">
    <div class="g-0 overlay">
        <div class="screen-card">
            <div class="logo">
                <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png" />
            </div>
            <div class="input-heading">
                This livestream will expire as soon as it is ended by the user or by "{{ LocalExpiryDate | date: 'dd/MM/yyyy h:mm:ss a' }}"
            </div>
            <div class="mfr-content">
              <video height="500" width="500" id="player-video" onloadedmetadata="this.muted = true" autoplay playsinline muted controls></video>
            </div>
        </div>

        <div class="term-of-services">
          <div class="version-text">
            © {{year}} {{siteCompany}} | Altitude version: {{version}}
          </div>
        </div>
    </div>
</div>

<div *ngIf="currentScreen === 'AccessDeniedScreen'" id="accessdenied-component" class="h-100 bg-image"
    style="background-image: url('assets/img/default-login.jpg')">
    <div class="g-0 overlay">
        <div class="screen-card">
            <div class="logo">
                <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png" />
            </div>
            <div class="mfr-title">Access Denied</div>
            <div class="input-heading">
                You are not authorised to access this livestream or the link has expired.
            </div>
        </div>

        <div class="term-of-services">
            <div class="version-text">
                © {{year}} {{siteCompany}} | Altitude version: {{version}}
            </div>
        </div>
    </div>
</div>

<div *ngIf="currentScreen === 'WebrtcfeedsErrorScreen'" id="webrtcfeedserror-component" class="h-100 bg-image"
    style="background-image: url('assets/img/default-login.jpg')">
    <div class="g-0 overlay">
        <div class="screen-card">
            <div class="logo">
                <img src="assets/img/c8b00319-2bb7-4001-9316-580b17ffc717_480.png" />
            </div>
            <div class="mfr-title">Streamed Error</div>
            <div class="input-heading">
                Live stream is not Available for {{ this.streamName.split("?")[0] }}
            </div>
        </div>

        <div class="term-of-services">
            <div class="version-text">
                © {{year}} {{siteCompany}} | Altitude version: {{version}}
            </div>
        </div>
    </div>
</div>
